import { useQuery } from 'react-query';

import { getTopUpBalanceByCreditCardSummary } from 'features/finance/api';

export const useTopUpBalanceByCreditCardSummary = (amount?: number, currency?: string) => {
  const result = useQuery(
    ['top-up-summary', amount, currency],
    async () => {
        if (!amount || !currency) return

      const result = await getTopUpBalanceByCreditCardSummary(amount, currency);
      return result.data;
    },
    {
      keepPreviousData: true,
      enabled: Boolean(amount && currency),
      staleTime: Infinity,
    }
  );

  return result;
};